import React from 'react';
import { HashRouter as Router, Route, Switch, Link } from 'react-router-dom';
import { Error } from '../Components/Error';
import App from '../App';
import Playarea from './Playarea';
import { baseUrl } from '../ApiHandler/EndPoints';


const MainFrame = () => {
    return(
        <Router>
            <MainFrameHeader />
            <Pages />
        </Router>
    );
}

const MainFrameHeader = () => {
    return(
        <div 
            className='d-flex justify-content-center p-1'
            style={{backgroundColor:'#000000'}}>
            <Link to='/'><h5 className='text-muted'>Gameboard</h5></Link>
        </div>
    );
}

const Pages = () => {
    return(
        <Switch>
            <Route path='/' exact component={Dashboard} />
            <Route path='/join' component={App} />
            <Route path='/play/:gameId' component={Playarea} />
            <Route path='/other/questions' component={Questions} />
            <Route path='/error' component={Error} />
        </Switch>
    );
}

const Dashboard = () => {
    return(
        <div className='container mb-2 mt-2'>
            <GameCardContainer />
            <OtherContainer />
        </div>
    );
}

const GameCardContainer = () => {
    const games = [
        {
            title: 'Free Play',
            desc: 'Play with questions from you and your friends!',
            mode:'free'
        },
        {
            title: 'Community Questions',
            desc: 'Play with 5 questions from the community! (Recommended for first timers or people looking for inspiration)',
            mode:'community'
        },
    ];
    return(
        <div>
            <h4>Games</h4>
            <div className='row'>
                {games.map(game => 
                    <GameCard 
                        key={game.mode}
                        title={game.title}
                        desc={game.desc}
                        mode={game.mode} />
                )}
            </div>
        </div>
    );
}

const GameCard = (props) => {
    return(
        <div className='col-lg-4 col-md-6'>
            <div className='card text-white bg-success mb-3'>
                <div className='card-header'>{props.title}</div>
                <div className='card-body'>
                    <p className='card-text'>{props.desc}</p>
                    <button className='btn btn-secondary'>
                        <Link
                            to={{
                                pathname:'/join',
                                state: { mode: props.mode }
                            }}
                            style={{ textDecoration: 'none' }}>Play!</Link>
                    </button>
                </div>
            </div>
        </div>
    );
}

const OtherContainer = () => {
    return(
        <div>
            <h4>Other</h4>
            <Link to='/other/questions'>View or Add a question to the community list.</Link>
        </div>
    );
}

const Questions = () => {
    return(
        <div className='container mt-2 mb-2'>
            <ListView />
            <Input />
        </div>
    );
}
 
class Input extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            formActive: false
        };
    }

    render(){
        if(this.state.formActive){
            return (<InputActive close={()=>this.setState({formActive:false})}/>);
        }
        return (<InputInactive onClick={()=>this.setState({formActive:true})}/>);
    }
}

class InputActive extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            question: '',
            valid: true,
            message: null
        }
    }
    render(){
        return(
            <div>
                {this.state.message &&
                <div onClick={()=>this.setState({message:null})} className="alert alert-dismissible alert-secondary">
                    <button type="button" className="close">&times;</button>
                    {this.state.message}
                </div>}
                <textarea 
                    id='question'
                    type='text'
                    rows='3'
                    maxLength='255'
                    value={this.state.question}
                    onChange={this.handleChange}
                    placeholder='Enter your question'
                    className={this.state.valid ? 'form-control' : 'form-control is-invalid'}
                    style={{fontWeight:'bold'}} />
                {!this.state.valid && <div className='invalid-feedback'>
                    Gotta add a little bit of text
                </div>}
                <div className='d-flex justify-content-between'>
                    <button className='btn btn-info py-2 mt-2' onClick={this.insertQuestionIntoDb}>
                        Add question
                    </button>
                    <button className='btn btn-danger py-2 mt-2' onClick={this.props.close}>
                        Nevermind
                    </button>
                </div>
            </div>
        );
    }

    handleChange = (e) => {
        let change = {};
        change[e.target.id] = e.target.value;
        change['valid'] = true;
        this.setState(change);
    }

    insertQuestionIntoDb = () => {
        if(!this.state.question){
            this.setState({valid:false});
            return;
        }
        const data = {
            question:this.state.question
        };

        fetch(`${baseUrl}/api/create/community-q`, {
            'method': 'POST',
            'body': JSON.stringify(data)
        })
        .then(res => {
            if(res.status===200){
                this.setState({message:'Success!  Thanks for the question.  We will review and approve it if it offends less than 50% of millenials.'});
            } else {
                this.setState({message:"Whoops!  Your question not added.  We'll make sure to fire the developer responsible."});
            }
        }).catch(()=>this.setState({message:"Whoops!  Your question not added.  We'll make sure to fire the developer responsible."}));
        this.setState({question:'', valid: true});
    }
}

const InputInactive = (props) => {
    //
    return(
        <div>
            <button
                onClick={props.onClick} 
                className='btn btn-success'>
                Add a question
            </button>
            <p>
                Add a question to be reviewed and submit to the list of community questions.
                <p className='text-muted'>
                    (We are currently working on a feature to save your favorite questions and view other favorite lists 
                    but until then please support the community list!)
                </p>
            </p>
        </div>
    );
}

class ListView extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            questions: ["These are not the questions you're looking for."]
        };
    }

    componentDidMount(){
        fetch(`${baseUrl}/api/read/community-qs`)
        .then(res => res.json())
        .then(questions => this.setState({questions}));
    }

    render(){
        const questions = this.state.questions;
        return(
            <div>
                <h4>Here's a sample of some of the community questions.</h4>
                {questions.map((q, i) => <p>{i+1}. {q}</p>)}
            </div>
        );
    }
}

export default MainFrame;